<template>
  <div class="process-item-param">
    <div class="process-bar">
      <div class="process-bar-item" v-for="(item, index) in listData" :key="index" :class="getBarItemClass(index, listData)">
        <div class="header">
          <div class="circle">{{ index + 1 }}</div>
          <div class="title">{{ item.title }}</div>
        </div>
        <div class="content">
          <template v-if="index > 0">
            <!-- <div class="sub-title">{{ item.subTitle }}</div> -->
            <div class="action">
              <span class="action-item" @click="editNode(item)">{{ $t('Common.com_edit') }}</span>
              <span v-if="index === listData.length - 1" class="action-item" @click="delNode(item)">{{ $t('Common.com_delete') }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="add-step">
        <div class="circle">
          <i class="icon icon-xinzeng"></i>
        </div>
        <div class="step-text" @click="addNode">
          {{ $t('base_process_item_param.xin_zeng_bu_zhou') }}
        </div>
      </div>
    </div>
    <div class="cc-msg">
      <el-form class="form" ref="form">
        <el-form-item :label="$t('base_process_item_param.shen_pi_chao_song')">
          <div class="process-bar cc-nodes">
            <div class="process-bar-item" v-for="(item, index) in ccNodes" :key="index" :class="getBarItemClass(index, ccNodes)">
              <div class="header">
                <div class="circle">{{ index + 1 }}</div>
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="content">
                <div class="action">
                  <span class="action-item" @click="editCcNode(item)">{{ $t('Common.com_edit') }}</span>
                  <span v-if="index === ccNodes.length - 1" class="action-item" @click="delCcNode(item)">{{ $t('Common.com_delete') }}</span>
                </div>
              </div>
            </div>
            <div class="add-step">
              <div class="circle">
                <i class="icon icon-xinzeng"></i>
              </div>
              <div class="step-text" @click="addCcNode">{{ $t('base_process_item_param.xin_zeng_chao_song') }}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" @click="onPrev">{{ $t('base_process_item_param.shang_yi_bu') }}</el-button>
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
    </div>
    <approval-process-node-dialog v-if="dialogVisible" @close="dialogVisible = false" :model="dialogModel" @add="initData" @edit="initData"></approval-process-node-dialog>
    <approval-cc-node-dialog v-if="dialog2Visible" @close="dialog2Visible = false" :model="dialog2Model" @add="initData" @edit="initData"></approval-cc-node-dialog>
    <select-user-dialog v-if="dialog1Visible" @close="dialog1Visible = false" :model="dialog1Model" @confirm="onUserUpdate"></select-user-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import approvalProcessNodeDialog from './approval_process_node_dialog';
import approvalCcNodeDialog from './approval_cc_node_dialog.vue';
import selectUserDialog from './select_user_dialog';

export default {
  components: {
    approvalProcessNodeDialog,
    selectUserDialog,
    approvalCcNodeDialog,
  },
  props: {
    workflowId: [String, Number],
    type: String,
  },
  data() {
    return {
      // 抄送类型
      ccType: 1,
      form: {
        // 选择用户信息
        approverIds: '',
        approverNames: '',

        // 抄送人所属组织
        approvalOrgType: '',
        // 抄送人所属岗位
        approvalRole: '',

        lostHandling: '',
        flowNodeId: '',
      },
      dialogVisible: false,
      dialogModel: {},

      // 审批节点列表
      approvalNodes: [],

      // 选择用户
      dialog1Visible: false,
      dialog1Model: {},

      // 新增，编辑抄送节点
      dialog2Visible: false,
      dialog2Model: {},

      workflowInfoBo: {},

      userNodes: [],
      copySendNodeList: [],
      nodeBoList: [],
    };
  },
  computed: {
    rules() {
      return {
        approvalOrgType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        approvalRole: {
          required: true,
          message: this.$t('Common.com_required'),
        }
      };
    },
    // 审批节点列表
    listData() {
      const ret = [
        {
          title: this.$t('base_process_item_param.shen_qing'),
        },
      ];
      const nodeBoList = this.nodeBoList;
      const nodes = nodeBoList;
      // eslint-disable-next-line prefer-arrow-callback
      nodes.forEach(function (item) {
        const title = this.$t('base_process_item_param.shen_pio', [item.flowNodeName]);
        const subTitle = item.flowNodeName;
        ret.push({
          ...item,
          title,
          subTitle,
        });
      });
      return ret;
    },
    // 抄送节点列表
    ccNodes() {
      const ret = [];
      const copySendNodeList = this.copySendNodeList;
      const nodes = copySendNodeList;
      nodes.forEach(function (item) {
        const map = this.dicMap.approval_org_type;
        const key = item.approvalOrgType
          .split(',')
          .map((val) => map[val])
          .join(',');
        const title = item.approvalOrgType ? this.$t('base_process_item_param.chao_songoo', [key,item.approvalRoleName]) : this.$t('base_process_item_param.chao_songo', [item.approverNames]);
        const subTitle = item.flowNodeName;
        ret.push({
          ...item,
          title,
          subTitle,
        });
      });
      return ret;
    },
    tags() {
      return this.form.approverNames ? this.form.approverNames.split(',') : [];
    },
  },
  watch: {
    'form.approvalOrgType': {
      handler(val) {
        if (val) {
          this.updateApprovalData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateApprovalData() {
      setTimeout(() => {
        this.$refs.approvalRole.getSelectList();
      }, 1000);
    },
    addUser() {
      this.dialog1Model = {
        title: this.$t('base_process_item_param.xuan_ze_yong_hu'),
        type: 'add',
        data: {
          selectedNodeIds: this.form.approverIds.split(','),
        },
      };
      this.dialog1Visible = true;
    },
    onUserUpdate(userNodes) {
      this.userNodes = userNodes;
      this.form.approverIds = userNodes.map((item) => item.bizId).join(',');
      this.form.approverNames = userNodes.map((item) => item.bizName).join(',');
    },
    // 获取抄送请求数据
    getCcReqData() {
      const ret = {
        workflowId: this.workflowId,
        lostHandling: this.form.lostHandling,
        flowNodeId: this.form.flowNodeId,
        // 写死
        flowNodeName: this.$t('base_process_item_param.chao_song'),
      };

      return ret;
    },
    // 获取保存请求数据
    getSaveReqData() {
      const { workflowClass, workflowDesc, workflowName, workflowType } = this.workflowInfoBo;
      return {
        workflowId: this.workflowId,
        isCc: this.ccType !== 3,
        workflowClass,
        workflowDesc,
        workflowName,
        workflowType,
      };
    },
    onPrev() {
      this.$emit('prev');
    },
    onCancel() {
      this.$emit('cancel');
    },
    save() {
      const reqData = this.getSaveReqData();
      this.$postJSON(apis.workflowInfoSave, reqData, true).then(() => {
        this.$message({
          type: 'success',
          message: this.type === 'edit' ? this.$t('Common.com_edit_success') : this.$t('Common.com_add_success'),
        });
        this.clearTagByKeep('processItem');
        this.jump('/examine/approvalProcess', {}, true);
      });
    },
    onSave() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 抄送用户
          if ([1, 2].includes(this.ccType)) {
            if (this.ccType === 1 && this.tags.length === 0) {
              this.$message.error(this.$t('base_process_item_param.qxxzcsyh'));
              return;
            }
            const reqData = this.getCcReqData();
            this.$postJSON(apis.apsWorkflowNodeCopySend, reqData, true).then(() => {
              this.save();
            });
            // 保存
          } else {
            this.save();
          }
        }
      });
    },
    getBarItemClass(index, list) {
      if (index > 0) {
        if (index === list.length - 1) {
          return 'last';
        }
        return 'middle';
      }
      return '';
    },
    // 删除流程审批节点
    delNode(node) {
      this.$showConfirm(this.$t('base_process_item_param.nqdyscxzdjdm')).then(() => {
        this.$deleteJSON(`${apis.apsWorkflowNodeDelete}/${node.flowNodeId}`).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.initData();
        });
      });
    },
    // 增加流程审批节点
    addNode() {
      this.dialogModel = {
        title: this.$t('base_process_item_param.xzlcjd'),
        type: 'add',
        data: {
          workflowId: this.workflowId,
        },
      };
      this.dialogVisible = true;
    },
    // 编辑流程审批节点
    editNode(node) {
      this.dialogModel = {
        title: this.$t('base_process_item_param.bjlcjd'),
        type: 'edit',
        data: node,
      };
      this.dialogVisible = true;
    },
    // 删除抄送节点
    delCcNode(node) {
      this.$showConfirm(this.$t('base_process_item_param.nqdyscxzdjdm')).then(() => {
        this.$deleteJSON(`${apis.apsWorkflowNodeDelete}/${node.flowNodeId}`).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.initData();
        });
      });
    },
    // 新增抄送节点
    addCcNode() {
      this.dialog2Model = {
        title: this.$t('base_process_item_param.xzcsjd'),
        type: 'add',
        data: {
          workflowId: this.workflowId,
        },
      };
      this.dialog2Visible = true;
    },
    // 编辑抄送节点
    editCcNode(node) {
      this.dialog2Model = {
        title: this.$t('base_process_item_param.bjcsjd'),
        type: 'edit',
        data: node,
      };
      this.dialog2Visible = true;
    },
    initData() {
      if (this.workflowId) {
        this.$getJSON(`${apis.workflowInfo}/${this.workflowId}`).then((res) => {
          this.$setFormatData(this.form, res.data.copySendNode || {});
          this.workflowInfoBo = res.data.workflowInfoBo;
          this.copySendNodeList = res.data.copySendNodeList || [];
          this.nodeBoList = res.data.nodeBoList || [];
        });
      }
    },
  },
  mounted() {
    this.getDicMap(
      'approval_org_type',
      () => {
        this.initData();
      },
      { propKey: 'value', propVal: 'name' }
    );
  },
};
</script>

<style lang="scss" scoped>
.process-item-param {
  padding-bottom: 50px;

  .el-tag {
    margin-right: 15px;
  }
  .process-bar {
    margin-left: 1px;
    margin-top: 4px;

    font-size: 12px;
    .process-bar-item {
      .header {
        overflow: hidden;
        width: 100%;
        .circle {
          float: left;
          width: 17px;
          height: 17px;
          border-radius: 100%;
          background: #4a90e2;
          line-height: 18px;
          text-align: center;
          color: #fff;
        }
        .title {
          float: left;
          color: #495057;
          line-height: 17px;
          margin-left: 12px;
          font-weight: bold;
        }
      }
      &.middle {
        .content {
          padding-bottom: 16px;
        }
      }
      &.last {
        .content {
          padding-bottom: 32px;
        }
      }
      .content {
        padding-left: 29px;
        min-height: 40px;
        overflow: hidden;
        position: relative;
        padding-bottom: 20px;

        &::before {
          content: ' ';
          position: absolute;
          width: 1px;
          background: #0d9ae0;
          left: 8px;
          top: 5px;
          bottom: 5px;
        }

        .sub-title {
          color: #6c757d;
          margin-top: 6px;
          height: 20px;
          line-height: 20px;
        }

        .action {
          overflow: hidden;
          line-height: 20px;
          height: 20px;
          margin-top: 6px;
          .action-item {
            float: left;
            margin-right: 15px;
            color: #4a90e2;
            cursor: pointer;
          }
        }
      }
    }
    .add-step {
      overflow: hidden;
      .circle {
        width: 17px;
        height: 17px;
        border-radius: 100%;
        background: #0d9ae0;
        float: left;
        text-align: center;
        line-height: 17px;
        color: #fff;
        .icon {
          display: inline-block;
          transform: scale(0.8, 0.8);
        }
      }
      .step-text {
        color: #0d9ae0;
        line-height: 18px;
        height: 17px;
        margin-left: 12px;
        float: left;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  .cc-nodes {
    width: 100%;
    overflow: hidden;
    padding-top: 20px;
  }

  .cc-msg {
    .form {
      margin-top: 10px;
      /deep/ {
        .el-form-item__label {
          padding-bottom: 0 !important;
          margin-top: 22px;
        }
        .el-radio {
          line-height: 31px;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
